import React from 'react';
import { inject } from 'mobx-react';
import ImportBillingTemplate from 'themes/modules/shipment-cost/pages/ImportBillingTemplate';

@inject(i => ({
	shipmentCostViewStore: i.rootStore.shipmentCostViewStore,
}))
class ImportBilling extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ImportBillingTemplate {...this.props} />;
	}
}

export default ImportBilling;



// WEBPACK FOOTER //
// ./src/modules/shipment-cost/pages/ImportBilling.jsx